<script setup lang="ts">
import { useSessionIndividual } from "~/composables/sessions/useSessionIndividual";

const sessionIndividual = useSessionIndividual();

const data = sessionIndividual.getSessionHistory();
const imgStep = ["/icons/generic/to do.svg", "/icons/generic/complete.svg"];

const aType: Record<string, string[]> = {
  request: ["Demande envoyée", "Demande validée", "Inscription confirmée", "Formation terminée"],
  invite: ["Invitation envoyée", "Inscription confirmée", "Formation terminée"],
  booking: ["Inscription confirmée", "Formation terminée"],
  project: ["Brouillon créé", "Invitation envoyée", "Inscription confirmée", "Formation terminée"],
};
</script>

<template>
  <div class="session_history__container">
    <h3 class="heading_3_demi text-primary-color p-[8px]">Historique</h3>
    <div class="session_history__grid">
      <span v-for="(sessionType, index) in aType[data.type]" :key="index">
        <section>
          <img :src="data.step >= index + 1 ? imgStep[1] : imgStep[0]" alt="" class="h-24 w-24" />
          <p>{{ sessionType }}</p>
        </section>
        <div v-if="index + 1 != aType[data.type].length"></div>
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.session_history__container {
  @apply pt-[8px];
  border-bottom: 1px solid var(--grey-lightest);
}

.session_history__grid {
  @apply flex flex-col px-[16px] mb-[32px] mt-[16px];

  section {
    @apply inline-flex;

    img {
      @apply w-[16px] h-[16px] mr-[8px];
    }
  }

  div {
    @apply w-[1px] h-[24px] m-[8px];
    background: var(--grey-medium-light);
  }
}
</style>
